<template>
  <a-modal
        :maskClosable="false"
          title="合伙人结算配置"
          :width="1000"
          :style="{'top':'10px'}"
          :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
          v-model="visibleModel"
          @cancel="handleCancel"
          @ok="handleOk"
  >
    <a-spin :spinning="saveLoading">
      <a-form :form="form">

        <a-form-item
                label="是否开启结算功能"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
        >
          <r-switch :formData="formData" field="open_order_reward" :checkedValue="1" :unCheckedValue="2" checkedChildren="开启" unCheckedChildren="关闭" />
        </a-form-item>

        <a-form-item
                v-show="formData.open_order_reward==1"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="规则配置"
                hasFeedback
        >
          <a-radio-group v-model="formData.open_order_reward_mode" buttonStyle="solid">
            <a-radio-button :value="1">以全局配置为准</a-radio-button>
            <a-radio-button :value="2">该商品单独配置</a-radio-button>
          </a-radio-group>
        </a-form-item>


        <div v-show="formData.open_order_reward_mode==2">
 
          <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="省级负责人"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'province_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="市级负责人"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'city_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="区域合伙人"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'partner_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="个人合伙人(5万分段)"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'user_partner_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="个人合伙人(15万分段)"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'user_partner_reward_percent2',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="服务专员"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'service_user_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="销售人"
                hasFeedback
                extra="订单内无推荐人情况"
        >
          <a-input type="number" v-decorator="[
          'sale_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="销售人(含推荐人)"
                hasFeedback
                extra="订单内有推荐人情况"
        >
          <a-input type="number" v-decorator="[
          'sale_recom_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="销售人(含推荐人和销售人)"
                hasFeedback
                extra="订单内有推荐人和销售人情况"
        >
          <a-input type="number" v-decorator="[
          'sale_recomm_recom_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="推荐人"
                hasFeedback
                extra="提成=完成订单实际支付商品金额的千分之几"
        >
          <a-input type="number" v-decorator="[
          'recomm_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="推荐人(含推荐人和销售人)"
                hasFeedback
                extra="订单内有推荐人和销售人情况"
        >
          <a-input type="number" v-decorator="[
          'recomm_sale_recom_reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                   placeholder="请输入比例"/>
        </a-form-item>
          

        </div>


      </a-form>

    </a-spin>
    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">取消</a-button>
      <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
  import RSwitch from '@/components/RSwitch/'
  import { getGoodsRewardSetting,goodsRewardSetting } from '@/api/goods'
  import PriceInput from '@/components/PriceInput/'

  export default {
    name: 'GoodsRewardForm',
    components: {
      RSwitch,
      PriceInput,
    },
    props: {
      goodsId:{
        type: String|Number,
        required: true
      },
      visible:{
        type: Boolean,
        default:false
      }
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        goods:{
          id:this.$route.query.id
        },
        saveLoading:false,
         
        formData:{
          goods_id:0,
          open_order_reward:1,
          open_order_reward_mode:1,
          province_reward_percent:0,
          city_reward_percent:0,
          partner_reward_percent:0,
          user_partner_reward_percent:0,
          user_partner_reward_percent2:0,
          service_user_reward_percent:0,
          sale_reward_percent:0,
          sale_recom_reward_percent:0,
          sale_recomm_recom_reward_percent:0,
          recomm_sale_recom_reward_percent:0,
          recomm_reward_percent:0,
        },
        sellerGroupSelectValue:undefined,
         
         
      }
    },
    watch: {
      goodsId(value){
        let that = this
        if(value){
          that.getPartnerCashSetting();
        }
      }
    },
    methods: {
       
      handleOk(e){
        let self = this
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
//            self.saveLoading = true;
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.formData.goods_id = self.goodsId;  
            goodsRewardSetting(Object.assign(self.formData,values)).then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false;
              this.$emit('sellerRewardDone')
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            console.log(err);
          }
        })
      },
      handleCancel(){
        this.$emit('sellerRewardDone')
      },

      getPartnerCashSetting(){
        let that = this
        getGoodsRewardSetting({ goods_id: that.goodsId }).then(res => {
          that.formData = res.data;
          that.form.setFieldsValue({...res.data});
        })
        .catch(err =>{
          that.$message.error(err.data.msg)
        })
      },
    },
       
    computed:{
      visibleModel:{
        get: function () {
          return this.visible;
        },
        set: function () {
        }
      },
    },
  }
</script>

<style lang="less" scoped>
</style>
